export default __webpack_public_path__ + "static/media/home4.e434e75f.jpg";